import { GetDraftCountsResponse } from '@cbinsights/draftqueueservice/draftqueueservice';
import { request } from 'client/modules/common/utils/request';

export const getDraftCounts = (): Promise<GetDraftCountsResponse> =>
  request({
    url: '/service/draftqueueservice/GetDraftCounts',
  }).then((r) => r.body);
